import React from 'react'
import './name.css'

const Name = () => {
  return (
	 <div className='myname mt-2'>
		<svg viewBox="0 5 660 110">
			<symbol id="s-text">
				<text textAnchor="middle" x="50%" y="90%">Ravi&nbsp;Kiran</text>
			</symbol>
			<g className = "g-ants">
				<use xlinkHref="#s-text" className="text-copy"></use>
				<use xlinkHref="#s-text" className="text-copy"></use>
				<use xlinkHref="#s-text" className="text-copy"></use>
				<use xlinkHref="#s-text" className="text-copy"></use>
				<use xlinkHref="#s-text" className="text-copy"></use>
			</g>
		</svg>
	 </div>
  )
}

export default Name